import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const searchRestrictionRuleSlice = createApi(`SearchRestrictionRuleSlice`,"POST");

const SearchRestrictionRuleSlice = createSlice({
  name: 'SearchRestrictionRuleSlicee',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(searchRestrictionRuleSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchRestrictionRuleSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(searchRestrictionRuleSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SearchRestrictionRuleSlice.reducer;